import { Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly _navigationOpenClass = 'navigation-open';
  private readonly _navigationActive = new BehaviorSubject<boolean>(false);
  public readonly navigationActive$ = this._navigationActive.asObservable();

  public toggleNavigation(renderer: Renderer2, document: Document): void {
    this._navigationActive.next(!this._navigationActive.value);
    if (this._navigationActive.value) {
      renderer.addClass(document.body, this._navigationOpenClass);
      return;
    }
    renderer.removeClass(document.body, this._navigationOpenClass);
  }

  public closeNavigation(renderer: Renderer2, document: Document): void {
    if (this._navigationActive.value) {
      this._navigationActive.next(false);
      renderer.removeClass(document.body, this._navigationOpenClass);
    }
  }
}
